import { SELECT_DATE_RANGE_TEXT } from "components/WasteDateRangePicker";

import { TileContentGreyBackground } from "./TileContentGreyBackground";

/** Shown in a date-scoped tile while the page has no date range (`WasteFacilityState.hasDateRange`). */
export function SelectDateRangePrompt() {
  return <TileContentGreyBackground>{SELECT_DATE_RANGE_TEXT}</TileContentGreyBackground>;
}
